import script from "./PortfolioIndexCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioIndexCard.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioIndexCard.vue?vue&type=style&index=0&id=46303742&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46303742"]])

export default __exports__